// extracted by mini-css-extract-plugin
module.exports = {"page-comp":"C_page-comp__L9p9f"};